import { LangCode } from '../models';

export interface ProductInput {
  id?: number;
  sku: number;
  category_id: number;
  brand_id: number;
  cost_price: number;
  price: number;
  warranty: number;
  guaranty: number;
  status: string; // possible value ['publish', 'draft'] and defualt value is draft
  stock: string; // possible value ['in', 'out'] and defualt is
  low_stock_level: number;
  qty: number;
  product_type: string; // possible value ['simple', 'variable', 'grouped', 'downloadable', 'virtual']
  parent_id: number; // parent product id is this varibale product
  related_id: number[]; // related products is the product ID's for example it like this product but in different brand staff will add the product id by search for this product by title
  discount_rate: string;
  start_discount: Date;
  end_discount: Date;
  img: string;
  thumbnail_id: string[];
  video_url: string;
  shipping: Shipping;
  dimension: Dimension;
  vat: string;
  search_code: string;
  translations: Translations[];
  attributes: Attributes[];
  tags: Tags[];
}

interface Shipping {
  country: string;
  cost: number;
  shipping_method: string;
}

interface Translations {
  lang_code: LangCode;
  title: string;
  description: string;
  features: Features;
  specification: Specification;
  seo_keyword: string;
  seo_title: string;
  seo_description: string;
}

interface Attributes {
  attribute_id: number;
  value_id: number;
}

interface Specification {
  weight: string;
  dimensions: string;
}

interface Features {
  [key: string]: string;
}

interface Dimension {
  width: number;
  height: number;
  length: number;
  weight: number;
}

interface Tags {
  tag_id: number;
}

export interface ProductFiltersInput {
  rating: number;
  minMaxPrice: number[];
  category: number[];
  color: number;
  brand: number[];
}

export interface ProductSearchInput {
  focus?: string;
  page: number;
  limit: number;
  query: string;
  category_ids: Array<number | string>;
  brand_ids: Array<number | string>;
  tag_ids: Array<number | string>;
  deal_ids?: Array<number | string>;
  color_names: Array<string>;
  primary_colour_slugs?: Array<string>;
  specifications: Array<ProductSearchInputSpec>;
  attribute_value_ids: Array<number | string>; // Not in use for now
  min_price: number;
  max_price: number;
  ratings: Array<number>;
  order: string;
  sort: 'asc' | 'desc';
  sales_source?: 'bazaar';
  is_search?: boolean;
  is_refurbished?: boolean;
  display_name?: string;
  explain?: boolean;
}

export interface ProductSearchInputSpec {
  name: string;
  value: string;
}


export interface SimpleProduct {
  id?: number;
  product_type: string;
  product_condition: string;
  category_id: number;
  department_id: number;
  subcategory_id: number;
  brand_id: number;
  is_featured: boolean;
  warranty_days: number;
  guarantee_days: number;
  product_variants: SimpleProductVariant[];
  product_tags: number[];
  add_ons: number[];
  related_products: number[];
}

export interface SimpleProductVariant {
  sku: string;
  color_value_id?: number | null;
  barcode?: string,
  partner_sku: string;
  regular_price: number;
  sale_price: number;
  sale_start_date: string;
  sale_end_date: string;
  cost_price: number;
  total_quantity: number;
  avilable_quantity?: number;
  reserved_quantity?: number;
  is_in_stock: boolean;
  weight_unit: string;
  weight_value: number;
  model_number: string;
  dimension_length: number;
  dimension_width: number;
  dimension_height: number;
  dimension_unit: string;
  produced_date: string;
  expiry_date: string;
  default_thumbnail: string;
  product_variant_translations: SimpleProductVariantTranslation[];
  product_variant_gallery: SimpleProductVariantGallery;
}

export interface SimpleProductVariantTranslation {
  language: string;
  name: string;
  description: string;
  variant_name: string;
  simple_color: string;
  simple_country_of_origin: string;
  features: string[];
  specifications_json?: SimpleProductSpecification[];
  whats_in_box: string;
  seo_title: string;
  seo_description: string;
  seo_keywords: string;
  seo_slug: string;
}

export interface SimpleProductSpecification {
  key: string;
  value_en: string;
  value_ar: string;
}

export interface SimpleProductVariantGallery {
  image_thumbnail_url: string;
  image_gallery_urls: string[];
  video_gallery: SimpleProductVideoGallery[];
}

export interface SimpleProductVideoGallery {
  url: string;
  thumbnail_url: string;
  title?: string;
  description?: string;
  duration?: number;
  order?: number;
}
export interface searchHistory {
  type: SearchHistoryInputType;
  display_query_name: string;
  product_variant_id: string | null;
  brand_id: string | null;
  category_id: string | null;
}
export type SearchHistoryInputType = 'category' | 'brand' | 'product_variant';

export interface BulkPurchaseRequest {
  product_variant_id: string;
  quantity: number;
  full_name: string;
  email: string;
  city: string;
  country?: string;
  mobile: string;
  additional_info?: string; // optional in case not always provided
}
export interface ProductListItem {
  id: string;
  parentId: string;
  name: string;
  description?: string;
  features?: unknown;
  salePrice: number;
  originalPrice: number;
  slug: string;
  discount: number;
  hasVariants: boolean;
  express: boolean;
  inWishlist: boolean;
  outOfStock: boolean;
  images: string[];
  rating: {
    maxStars: number;
    activeStars: number;
    averageRating: number;
    totalRatings: number;
  };
  tickers: {
    hasFreeDelivery: boolean;
    hasCashOnDelivery: boolean;
    isRefurbished: boolean;
    isLimitedEdition: boolean;
  };
}

export interface productQuickUpdateInput {
  regular_price: number;
  sale_price: number;
  cost_price: number;
  sale_start_date: string;
  sale_end_date: string;
}
export interface productQuickUpdateStockInput {
  total_quantity: number;
}
